export namespace LockerApiUri {
  const BASE_URL = '/lcm/locker/api';
  const LCOPS_BASE_URL = '/lcm/lcops/api';
  const BASE_URL_V2 = `${BASE_URL}/v2`;
  export namespace Password {
    export const PASSWORDS_BASE_URL = `${BASE_URL}/passwords`;

    export const GET_PASSWORD_ALIASES_URL = `${PASSWORDS_BASE_URL}/list/vmids`;

    export const GET_PASSWORD_BY_VMID_URL = (vmid: string) =>
      `${PASSWORDS_BASE_URL}/detail/${vmid}`;
  }

  export namespace License {
    export const LICENSES_BASE_URL = `${BASE_URL}/licenses`;

    export const NON_EVALUATION_LICENSES_URL = (legacyOnly: boolean) =>
      `${BASE_URL}/licenses?legacyOnly=${legacyOnly}`;

    export const CONTAINER_LICENSES_URL = `${LCOPS_BASE_URL}/containers/licenses`;

    export const GET_LICENSE_BY_VMID_URL = (vmid: string) =>
      `${LICENSES_BASE_URL}/detail/${vmid}`;

    export const GET_LICENSE_BY_ALIAS_URL = (alias: string) =>
      `${LICENSES_BASE_URL}/alias/${alias}`;

    export const VALIDATE_LICENSE_URL = `${BASE_URL}/license/validate`;

    export const GET_VALID_PRODUCT_LICENSES_URL = (
      environmentId: string,
      productId: string,
      tenantId: string
    ) => {
      const searchParams = new URLSearchParams();
      if (['vro', 'vssc'].includes(productId) && tenantId) {
        searchParams.append('tenantId', tenantId);
      }

      return `${BASE_URL}/license/validReplace/${environmentId}/${productId}?${searchParams.toString()}`;
    };

    export const LICENSE_ASSOCIATION_URL = `${BASE_URL}/license/validateAssociation`;

    export const GET_PRODUCT_LICENSE_URL = (
      environmentId: string,
      productId: string,
      tenantId: string
    ) => {
      const searchParams = new URLSearchParams();
      if (['vro', 'vssc'].includes(productId) && tenantId) {
        searchParams.append('tenantId', tenantId);
      }
      return `${LICENSES_BASE_URL}/currentlicenses/${environmentId}/${productId}?${searchParams.toString()}`;
    };

    export const GET_LICENSE_ASSOCIATION_URL = (tenantId?: string) => {
      const searchParams = new URLSearchParams();
      if (tenantId) {
        searchParams.append('tenantId', tenantId);
      }
      return `${LICENSE_ASSOCIATION_URL}?${searchParams.toString()}`;
    };

    export const REPLACE_LICENSE_URL = (vmid: string) =>
      `${LICENSES_BASE_URL}/replace/${vmid}`;

    export const SAAS_ENDPOINT_DISCONNECT_URL = (vmid: string) =>
      `${LICENSES_BASE_URL}/${vmid}/org`;
  }

  export namespace CertificateV2 {
    export const CERTIFICATES_BASE_URL = `${BASE_URL_V2}/certificates`;

    export const IMPORT_CERTIFICATE_URL = `${CERTIFICATES_BASE_URL}/import`;
  }

  export namespace Certificate {
    export const CERTIFICATES_BASE_URL = `${BASE_URL}/certificates`;

    export const VALIDATE_CERTIFICATE_FILE_URL = `${CERTIFICATES_BASE_URL}/validate`;
  }

  export namespace Security {
    export const SECURITY_BASE_URL = `${BASE_URL}/security`;

    export const FIPS_DATA_URL = `${SECURITY_BASE_URL}/fips`;
  }

  export namespace Policies {
    const POLICIES_BASE_URL = `${BASE_URL}/policies`;

    export const GET_NOTIFICATION_TRIGGERS_URL = `${POLICIES_BASE_URL}/notificationTriggers`;
  }
}
